/*
 * @Description  : 
 * @Author       : git config user.sname
 * @Date         : 2025-03-27 11:19:21
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-12-22 16:30:39
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\ca.js
 */
// ca证书接口集合
import request from "../request.js";

//  查询ca证书列表 ---- 于祥东
export const getCAList = function (data) {
    return request({
        url: 'userTenantCenter/selectCaDetailPageList',
        method: 'post',
        data
    })
}

//CA数字证书-CA办理记录分页列表  ------叶凡
export const getPageCas = function (data) {
    return request({
        url: '/ahCa/getPageCas',
        method: 'post',
        data
    })
}